import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { Box, Typography } from '@material-ui/core';
import moment from 'moment';
import React, { FC, useContext, useState } from 'react';
import Backdrop from '../../../Components/Backdrop';
import CardHistory from '../../../Components/CardHistory/CardHistory';
import { classnames } from '../../../Components/MapComponent/helper';
import { DO_GET_BILL_DELIVERY_USER } from '../../../Graphql/Bill/query';
import {
  GET_BILL_DELIVERY_USER,
  GET_BILL_DELIVERY_USERVariables,
} from '../../../Graphql/Bill/types/GET_BILL_DELIVERY_USER';
import filehistory from '../../../Images/filehistory.svg';
import SnackVariableInterface from '../../../Interfaces/SnackVariableInterface';
import { UserContext } from '../../../Providers/User';
import { displaySnackBar } from '../../../Utils/snackBarUtils';
import useStyles from './style';
import FactureDetail from './FactureDetail';
interface livraison {
  value?: string | null;
  setValue?: (params: any) => void;
  index?: number;
  setIndex: (index: any) => void;
  showDetails?: () => void;
  handleClickButton: () => void;
}
const HistoriqueLivraison: FC<livraison> = ({
  setValue,
  setIndex,
  showDetails,
  handleClickButton
}) => {
  const classes = useStyles();
  const { customerId } = useContext(UserContext);
  const client = useApolloClient();
  const [active, setActive] = useState(0);

  const { data, loading } = useQuery<
    GET_BILL_DELIVERY_USER,
    GET_BILL_DELIVERY_USERVariables
  >(DO_GET_BILL_DELIVERY_USER, {
    variables: { customer_id: customerId },
    skip: customerId ? false : true,
    fetchPolicy: 'cache-and-network',
    onError: (err) => {
      if (err.networkError?.message === 'Failed to fetch') {
        const snackBarData: SnackVariableInterface = {
          type: 'ERROR',
          message: 'Problème de connexion...',
          isOpen: true,
        };
        return displaySnackBar(client, snackBarData);
      }
      const snackBarData: SnackVariableInterface = {
        type: 'ERROR',
        message: err.message.split(':')[1],
        isOpen: true,
      };
      return displaySnackBar(client, snackBarData);
    },
    onCompleted: () => {
      setValue && setValue(data?.billsDeliveryUser[0]);
    },
  });

  const [selectedBill, setSelectedBill] = useState<any>(null);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  };  

  const handleClick = (index: any | null) => {
    if (index) {
      const selected = data?.billsDeliveryUser[index - 1];
      setValue && setValue(selected);
      setSelectedBill(selected);

      handleClickButton()
    }
  };
  const Listehistoriques =
    data &&
    data.billsDeliveryUser.map((item, index) => {
      let numero = index + 1;
      return (
        <Box
          key={`${index}`}
          className={classnames(
            classes.demandeContainer,
            active === index ? classes.clicked : '',
          )}
          onClick={() => {
            handleClick(numero);
            setActive(index);
          }}>
          <img src={filehistory}></img>
          <Backdrop open={loading} />
          <CardHistory
            titre={item.reference}
            date={moment(item.datePaymentBill).format('DD-MM-YYYY')}
            price={+item.amountTotal}
          />
        </Box>
      );
    });

  return (
    <>
      <Backdrop open={loading} />
      <ul>{Listehistoriques}</ul>
    </>
  );
};
export default HistoriqueLivraison;
